import React from 'react'

import logoSmall from 'assets/img/logo-small.png'
import logoLarge from 'assets/img/logo-large.png'

type Props = {
  size: 'small' | 'large'
}

const LogoWhite = ({ size }: Props) => {
  return (
    <img
      className="logo"
      src={size === 'small' ? logoSmall : logoLarge}
      alt="Logo brand"
    />
  )
}

export default LogoWhite
